import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Hero from './Hero';
import About from './About';
import Skills from './Skills';
import AIMLSection from './AIMLSection';
import DSASection from './DSASection';
import Projects from './Projects';
import GitHubLeetCode from './GitHubLeetCode';
import Contact from './Contact';
import Header from './Header';
import '../styles/portfolio.css';

const Portfolio = () => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'skills', 'aiml', 'dsa', 'projects', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="portfolio-container">
      <Header activeSection={activeSection} />
      <Hero />
      <About />
      <Skills />
      <AIMLSection />
      <DSASection />
      <Projects />
      <GitHubLeetCode />
      <Contact />
    </div>
  );
};

export default Portfolio;